export const QA_NAME_GRETA_AI_CHAT_PROJECT = 'gretaAIChatProject'

export const QA_NAME_GRETA_AI_CHAT_PROJECT_TOGGLE = 'gretaAIChatProjectToggle'

export const QA_NAME_GRETA_AI_CHAT_PROJECT_CHATS_ALL =
  'gretaAIChatProjectChatsAll'
